var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 38,
    viewBox: "0 0 32 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8105 0H5.41549C2.42931 0 0 2.49397 0 5.55963V28.831C0 31.8967 2.42931 34.3906 5.41549 34.3906H11.0794C11.6963 34.3906 12.1973 33.8763 12.1973 33.243C12.1973 32.6097 11.6963 32.0954 11.0794 32.0954H5.41549C3.66312 32.0954 2.23575 30.6322 2.23575 28.831V5.55963C2.23575 3.75849 3.66105 2.29526 5.41549 2.29526H25.8105C27.5629 2.29526 28.9903 3.75849 28.9903 5.55963V28.831C28.9903 30.2432 28.1136 31.4854 26.8052 31.9232C26.2173 32.1198 25.8985 32.767 26.09 33.3705C26.2815 33.9741 26.9129 34.3003 27.4998 34.1048C29.7293 33.3588 31.2271 31.2378 31.2271 28.831V5.55963C31.226 2.49397 28.7967 0 25.8105 0Z",
    fill: "url(#paint0_linear_2_508)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1166 19.8635C15.8251 19.8635 13.1443 22.6125 13.1443 25.9927C13.1443 27.6972 13.8285 29.239 14.9267 30.3516V36.8527C14.9267 37.2746 15.1523 37.6624 15.5146 37.8622C15.8769 38.063 16.3168 38.0428 16.6604 37.8112L19.1187 36.1567L21.577 37.8112C21.7613 37.9366 21.9755 37.9993 22.1908 37.9993C22.3719 37.9993 22.5562 37.9536 22.7228 37.8611C23.0841 37.6614 23.3108 37.2735 23.3108 36.8516V30.3484C24.4079 29.2369 25.0921 27.695 25.0921 25.9895C25.0869 22.6125 22.4092 19.8635 19.1166 19.8635ZM19.1166 22.1577C21.1744 22.1577 22.8501 23.8781 22.8501 25.9927C22.8501 28.1063 21.1744 29.8267 19.1166 29.8267C17.0569 29.8267 15.3821 28.1063 15.3821 25.9927C15.3821 23.8781 17.0579 22.1577 19.1166 22.1577ZM21.0709 34.7264L19.7325 33.8232C19.3589 33.5735 18.8775 33.5735 18.5049 33.8232L17.1655 34.7264V31.7574C17.7804 31.9785 18.4314 32.1219 19.1177 32.1219C19.806 32.1219 20.456 31.9774 21.0698 31.7574V34.7264H21.0709Z",
    fill: "url(#paint1_linear_2_508)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74874 15.6163H12.9096C13.5265 15.6163 14.0275 15.102 14.0275 14.4687C14.0275 13.8343 13.5265 13.321 12.9096 13.321H7.74874C7.1308 13.321 6.63086 13.8354 6.63086 14.4687C6.63086 15.1031 7.1308 15.6163 7.74874 15.6163Z",
    fill: "url(#paint2_linear_2_508)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74874 9.37754H19.2297C19.8477 9.37754 20.3476 8.86323 20.3476 8.2299C20.3476 7.59658 19.8466 7.08228 19.2297 7.08228H7.74874C7.1308 7.08228 6.63086 7.59658 6.63086 8.2299C6.63086 8.86323 7.1308 9.37754 7.74874 9.37754Z",
    fill: "url(#paint3_linear_2_508)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_508",
    x1: 0.00133849,
    y1: 17.1955,
    x2: 31.2282,
    y2: 17.1955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_508",
    x1: 13.1448,
    y1: 28.9318,
    x2: 25.0925,
    y2: 28.9318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_508",
    x1: 6.63118,
    y1: 14.4687,
    x2: 14.0277,
    y2: 14.4687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_508",
    x1: 6.63145,
    y1: 8.22992,
    x2: 20.3481,
    y2: 8.22992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0112,
    stopColor: "#FD225C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE7A40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon12);
export default __webpack_public_path__ + "static/media/icon-12.6598632262b18772ad943f3cd91e93a6.svg";
export { ForwardRef as ReactComponent };